import React from 'react';

type EmbeddedModalContextType = {
	embeddedParentModalKey: string | undefined;
	forwarder: ({ data }: any) => Promise<any>;
	setEmbeddedParentModalKey: React.Dispatch<React.SetStateAction<string | undefined>>;
};

export const EmbeddedModalContext: React.Context<EmbeddedModalContextType> =
	React.createContext<EmbeddedModalContextType>({
		embeddedParentModalKey: undefined,
		setEmbeddedParentModalKey: () => {},
		forwarder: () => Promise.resolve(),
	});
